export interface Timestamp {
  counter: number;
  device_id: string;
}

export interface LWWRegister<T> {
  value: T;
  ts: Timestamp;
}

export function compareTimestamp(a: Timestamp, b: Timestamp): number {
  if (a.counter !== b.counter) {
    return a.counter - b.counter;
  }
  return a.device_id.localeCompare(b.device_id);
}

export function mergeLWWRegister<T>(
  local: LWWRegister<T> | undefined,
  remote: LWWRegister<T> | undefined,
): LWWRegister<T> | undefined {
  if (!local) return remote;
  if (!remote) return local;
  return compareTimestamp(local.ts, remote.ts) >= 0 ? local : remote;
}

export function stampRegister<T>(
  value: T,
  counter: number,
  deviceId: string,
): LWWRegister<T> {
  return { value, ts: { counter, device_id: deviceId } };
}
